module.exports = __webpack_public_path__ + "static/img/banner_pc.1583263.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/module/active_jd/images/banner_pc.jpg
// module id = 0zRE
// module chunks = 91